const Footer = () => {
   return (
    <>
    <footer style={{margin: "0px", width: "100%", bottom: "0px"}}>
        <div className="mainFooter" dir="rtl">
        
        <div className="containerFooter">
            
            <div className="rightContentFooter">
                <h3 style={{ padding: "4px"}}>اطلاعات تماس</h3>
                <hr></hr>
                <h5 className="pt-2">مشهد: </h5>
                <ul>
                    <li>مشهد، خیابان پاسداران، پاسداران ۳/۱، پلاک ۲۴</li>
                    <li>۰۵۱-۳۲۲۳۸۷۰۸-۹</li>
                    <li>info@modaghegh.com</li>  
                </ul>
                {/* <hr></hr> */}
                <h5 className="pt-1">تهران: </h5>
                <ul>

                    <li>شنبه  هماهنگی با آقای رضانژاد ۰۹۳۳۳۱۹۱۳۶۳ - ۱۴:۰۰ - ۱۶:۰۰</li>
                    <li>یکشنبه بیمارستان ولایت - ۱۰:۰۰ - ۱۲:۰۰</li>
                    <li>دوشنبه - ۱۷:۰۰ - ۲۰:۰۰</li>  
                    <li>سه شنبه بیمارستان مادر - ۱۷:۰۰ - ۱۸:۰۰</li>  
                    <li>چهارشنبه - ۱۷:۰۰ - ۲۰:۰۰</li>  
                </ul>
            </div>
            <div className="centerContentFooter">
                <div className="map">
                    <iframe   height='300' id='gmap_canvas' src='https://maps.google.com/maps?q=36.28949411095911,59.59593718465607&z=14&ie=UTF8&iwloc=&output=embed' frameborder='0' scrolling='no' marginheight='0' marginwidth='0'></iframe>
                </div>
            </div>
            <div className="leftContentFooter">
                <ul >
                    <li className="pt-2">صفحه اصلی</li>
                    <li className="pt-2">درباره دکتر مدقق</li>
                    <li className="pt-2">اخبار و مقالات</li>
                    <li className="pt-2">مکان های گردشگری مشهد</li>
                    <li className="pt-2">حرم امام رضا(ع)</li>
                    <li className="pt-2">راه های ارتباطی</li>
                    <li className="pt-2">گالری</li>
                    <li className="pt-2">نوبت دهی</li>
                    <li className="pt-2">سامانه ثبت بیماری</li>
                </ul>

                <div className="w-100 "  >
                    <img src="/image/telegram-128.png" width='40' className="ms-4 mt-3"  />
                    <img src="/image/whatsapp-128.png" width='40' className="ms-4 mt-3"  />
                    <img src="/image/instagram-128.png" width='40' className="ms-4 mt-3"  />
                
                </div>
            </div>
            
        </div>

        
        
    </div>
    <div className="buttomContentFooter">
        <p className="p-1">تمامی حقوق برای کلینیک فوق تخصصی جراحی عروق مشهد محفوظ است. </p>
    </div>
</footer>
</>

   )
}

export default Footer;